import type { JSX } from 'solid-js';

import { formatPhoneNumber } from '~/lib/helpers/format-phone';
import { locale } from '~/lib/i18n';

export default function Header(): JSX.Element {
    const phone = () => locale().support.number;
    const email = () => locale().support.email;

    return (
        <header class="flex justify-between items-center bg-brand-blue text-white w-full pl-4 pr-6 py-4 md:pt-[27px] md:pb-[21px] md:px-10 h-14 md:h-20">
            {/* Logo */}
            <a href="/" class="flex items-center">
                <img
                    src="/getsolar-horizontal-white-yellow.png"
                    alt="GetSolar"
                    width={160}
                    height={32}
                />
            </a>

            {/* Contact links */}
            <div class="flex items-center">
                <a
                    href={`mailto:${email()}?subject=Request For Solar Quote From GetSolar`}
                    class="flex items-center mr-5">
                    <img
                        src="/email_white.svg"
                        alt="Email"
                        width={20}
                        height={20}
                        class="mr-2"
                    />
                    <span class="hidden md:inline-block text-sm">
                        {email()}
                    </span>
                </a>
                <a href={`tel:${phone()}`} class="flex items-center">
                    <img
                        src="/phone_white.svg"
                        alt="Phone"
                        width={20}
                        height={20}
                        class="mr-1.5"
                    />
                    <span class="hidden md:inline-block text-sm">
                        {formatPhoneNumber(phone())}
                    </span>
                </a>
            </div>
        </header>
    );
}
